import React from "react";

export function FileUploadInput({ inputRef, onChange }) {
  const handleOnChange = (event) => {
    onChange(event.target.files[0]);
    inputRef.current.value = "";
  };

  return (
    <input
      aria-label="Upload reference time card"
      type="file"
      onChange={handleOnChange}
      ref={inputRef}
      accept="application/pdf, image/*"
      style={{ display: "none" }}
    />
  );
}
